export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const SET_CURRENT_ORGANIZATION = "SET_CURRENT_USER_ORGANIZATION";
export const RESET_USER = "RESET_USER";
